var alertTriggerControls = {
	limits: "Limits",
	upperLimit: "Limite supérieure",
	upperLimitPlaceholder: "Limite supérieure",
	lowerLimit: "Limite inferieure",
	lowerLimitPlaceholder: "Limite inferieure",
	deleteBtn: "Effacer",
	cancelBtn: "Annuler",
	saveBtn: "Ok",
	validationErrors: {
		upperLimit: {
			invalidInput: "Saisie non valide. Modèle valide: 123.456",
			priceMismatch: "The upper limit must be higher than the current price"
		},
		lowerLimit: {
			invalidInput: "Saisie non valide. Modèle valide: 123.456",
			priceMismatch: "The lower limit must be lower than the current price"
		}
	}
};
var fr = {
	alertTriggerControls: alertTriggerControls
};

export { alertTriggerControls, fr as default };
